/**
 * author: Ananthapadmanabhan V K
 */
import React, { useEffect, useState } from 'react';
import './InvitationList.scss';
import { withTranslation } from 'react-i18next';
import InvitationService from '../../../core/service/InvitationService';
import { useNavigate } from 'react-router-dom';
import { Button, Table, Form, Badge, Pagination } from 'react-bootstrap';
import ErrorHandlingService from '../../../core/service/ErrorHandlingService';

const InvitationList = ({ t }) => {
  const navigate = useNavigate();
  const [InvitationData, SetInvitationData] = useState([]);
  useEffect(() => {
    getInvitations();
  }, []);

  const getInvitations = () => {
    InvitationService.getInvitationsList()
      .then((response) => {
        SetInvitationData([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
      });
  };

  return (
    <section className="InvitationList">
      <div className='List_header'>
        <h5 className='MH'>{t("InvitationList.label")}</h5>
      </div>

      <div className='col-lg-8'>
        <div className='List_Table_02'>
          <div className='card List_table-card02'>
            <Table responsive="sm">
              <thead>
                <tr>
                  <th>{t("Name.label")}</th>
                  <th>{t("Status.label")}</th>
                  <th>{t("Action.label")}</th>
                </tr>
              </thead>
              <tbody>
                {InvitationData?.map((item) => (
                  <tr key={item.activationKey}>
                    <td className='cursor'>
                      <span onClick={() => { navigate(`/company_admin/company_onboard/${item.activationKey}`); }}>
                        {item.name}
                      </span>
                    </td>
                    <td>{item.status}</td>
                    <td></td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {/* <div className='p-2 List_footer'>
              <div className='p-2 List_footer_count'>
                <div className='Item_per_pageBox'>
                  Items per page
                  <select>
                    <option>10</option>
                    <option>20</option>
                    <option>30</option>
                  </select>
                </div>
                <div className='Count_pages02'>
                  1 - 10 of 50
                </div>
                <Pagination>
                  <Pagination.First />
                  <Pagination.Prev />
                  <Pagination.Item>{1}</Pagination.Item>
                  <Pagination.Item active>{2}</Pagination.Item>
                  <Pagination.Item>{3}</Pagination.Item>
                  <Pagination.Next />
                  <Pagination.Last />
                </Pagination>
              </div>
            </div> */}
          </div>
        </div>
      </div>




    </section>
  )
};

export default withTranslation()(InvitationList);
